var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-mining-section shadow" },
    [
      _c("div", { staticClass: "staking-detail" }, [
        _c("div", { staticClass: "item no-border" }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("inviteMining.inviteTradeIncome")))]),
          _vm._v(" "),
          _c("div", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.inviteTotal || "--"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "mint-trade-table no-shadow tb",
          attrs: { headList: _vm.inviteHeadList, contentList: _vm.content }
        },
        [
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              slot: "tableBottom",
              currentPage: _vm.inviteCurrentPage + 1,
              toPage: _vm.fetchMiningInvite,
              totalPage: _vm.inviteTotalPage
            },
            slot: "tableBottom"
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }